import type { HeaderContext } from '@tanstack/react-table';
import type { Song } from './types';
import { Table } from '~/components/ui/table';

type Props = HeaderContext<Song, unknown> & {
  children?: React.ReactNode;
  hideBelow?: 'md';
  minW?: string;
  p?: { base: number; md: number };
  textAlign?: 'center';
};

export function SortableHeader({ column, children, hideBelow, minW, p, textAlign }: Props) {
  return (
    <Table.Header
      onClick={column.getCanSort() ? column.getToggleSortingHandler() : undefined}
      hideBelow={hideBelow}
      minW={minW}
      p={p}
      textAlign={textAlign}
    >
      {children}
      {column.getIsSorted() === 'asc' ? ' ▲' : column.getIsSorted() === 'desc' ? ' ▼' : null}
    </Table.Header>
  );
}
